// Parse @mentions from free text by matching against family member names.
// Returns array of matched user_ids. Matches @FirstName or @"Full Name".
export function parseMentions(text, members) {
  if (!text || !members?.length) return [];
  const lower = text.toLowerCase();
  const ids = new Set();
  for (const m of members) {
    const name = (m.name || "").toLowerCase();
    const first = name.split(" ")[0];
    if (!name) continue;
    if (lower.includes("@" + name) || (first && lower.includes("@" + first))) {
      ids.add(m.user_id || m.id);
    }
  }
  return [...ids];
}
